import { BOARD_TYPES } from './constants';

function getSteps(section, intl, user) {
  switch (section) {
    case BOARD_TYPES.TASK:
      return [
        {
          target: 'body',
          placement: 'center',
          content: intl.formatMessage(
            { id: 'tooltips.task.igtask_intro' },
            { name: user.shortName || '' },
          ),
          disableBeacon: true,
        },
        {
          target: '#tasks-board-header',
          content: intl.formatMessage({ id: 'tooltips.task.tasks_board' }),
        },
        {
          target: '.lane-to_do',
          content: intl.formatMessage({ id: 'tooltips.task.todo' }),
        },
        {
          target: '.add-note-button',
          content: intl.formatMessage({ id: 'tooltips.task.igtask_new_card' }),
        },
        {
          target: '.lane-doing',
          content: intl.formatMessage({ id: 'tooltips.task.doing' }),
        },
        {
          target: '.lane-done',
          content: intl.formatMessage({ id: 'tooltips.task.done' }),
        },
        {
          target: '#tasks-peformance-chart',
          content: intl.formatMessage({ id: 'tooltips.task.igtask_chart' }),
        },
        {
          target: 'body',
          placement: 'center',
          content: intl.formatMessage({ id: 'tooltips.task.igtask_learn_btn' }),
        },
      ];

    case BOARD_TYPES.CEO:
      return [
        {
          content: intl.formatMessage({ id: 'tooltips.ceo.igceo_intro' }, { name: user.shortName }),
          target: 'body',
          placement: 'center',
          disableBeacon: true,
        },
        {
          target: '.lane-to_execute',
          content: intl.formatMessage({ id: 'tooltips.ceo.to_execute' }),
        },
        {
          target: '.lane-doing',
          content: intl.formatMessage({ id: 'tooltips.ceo.igceo_doing' }),
        },
        {
          target: '.lane-done',
          content: intl.formatMessage({ id: 'tooltips.ceo.igceo_done' }),
        },
        {
          content: intl.formatMessage({ id: 'tooltips.ceo.igceo_tasks_types' }),
          target: 'body',
          placement: 'center',
        },
        {
          target: '.lane-build_product',
          content: intl.formatMessage({ id: 'tooltips.ceo.build_product' }),
        },
        {
          target: '.lane-recruiting',
          content: intl.formatMessage({ id: 'tooltips.ceo.recruiting' }),
        },
        {
          target: '.lane-finances',
          content: intl.formatMessage({ id: 'tooltips.ceo.finances' }),
        },
        {
          target: '.lane-bmc',
          content: intl.formatMessage({ id: 'tooltips.ceo.igceo_bmc' }),
        },
        {
          // target: "#igceo-learn-btn",
          target: 'body',
          placement: 'center',
          content: intl.formatMessage({ id: 'tooltips.ceo.igceo_learn_btn' }),
        },
      ];

    default:
      return [];
  }
}

const TOOLTIPPROPS = {
  getSteps,
  sections: { ...BOARD_TYPES, default: BOARD_TYPES.TASK },
};

export { TOOLTIPPROPS };
